/*
	页面相关api
**/
import $axios from "@/service/httpServer";
// 获取我的页面列表
export const getMyPages = (p) =>
  $axios.post("/exhibitionItemsTemplate/designerQueryPage", p);
// 获取我的页面详情
export const getPageDetail = (p) =>
  $axios.get("/resources/getByExhibitionId", p);
// 新增页面
export const createPage = (p) => $axios.post("/quark/page/create", p);
// 更新页面
export const updatePage = (p) =>
  $axios.post("/resources/saveOrUpdateContent", p);
// 提交模板
export const submitPage = (p) =>
  $axios.get("/exhibitionItemsTemplate/updateSubmitStatus", p);
// 删除页面
export const deletePage = (p) =>
  $axios.post("/exhibitionItemsTemplate/delete", p);
// 复制页面
export const copyPage = (p) => $axios.post("/quark/page/copy", p);
// 设置为模板
export const setTemplatePage = (p) => $axios.post("/quark/page/setTemplate", p);
// 发布页面
export const publishPage = (p) => $axios.post("/quark/page/setPublish", p);

// 复制模板
export const copyTemplate = (p) =>
  $axios.get("exhibitionItemsTemplate/clone", p);
/**
 * ========================================================================
 * */
// 获取我的模板
export const getMyTemplates = (p) =>
  $axios.get("/quark/page/getMyTemplates", p);

/**
 * ========================================================================
 * */
// 获取模板市场模板
export const getPublishTemplates = (p) =>
  $axios.get("/quark/page/getPublishTemplates", p);

/**
 * ========================================================================
 * */
// 获取协作人列表
export const getCooperationUserListByPageId = (p) =>
  $axios.get("/quark/page/getCooperationList", p);
// 按userIds添加协作人
export const addCooperation = (p) =>
  $axios.post("/quark/page/addCooperation", p);
// 删除协作人
export const delCooperation = (p) =>
  $axios.post("/quark/page/delCooperation", p);
